import React from 'react';
import './CSS/gallery.css';
import 'normalize.css';
import etsy1 from '../src/Images/etsy1.jpg';
import etsy2 from '../src/Images/etsy2.jpg';
import etsy3 from '../src/Images/etsy3.jpg';
import etsy4 from '../src/Images/etsy14.jpg';
import etsy5 from '../src/Images/etsy5.jpg';
import etsy6 from '../src/Images/etsy6.jpg';
import etsy7 from '../src/Images/etsy7.jpg';
import etsy8 from '../src/Images/etsy8.jpg';
import etsy9 from '../src/Images/etsy9.jpg';
import etsy11 from '../src/Images/etsy11.jpg';
import etsy12 from '../src/Images/etsy12.jpg';
import etsy13 from '../src/Images/etsy13.jpg';
function Gallery() {
  return (
    <div className="container">	
      <div className="gallery_grid">
        <div className="gallery_grid_item">
          <article className="card orange__red">
            <h1 className="monoton">Gallery</h1>
            <h3 className="homepage_text">Hover over any items to see where you can find them.</h3>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card">
            <div className="img__container">
              <div className="image">			
                <img src={etsy1} alt="Etsy shop example work" />
                <div class="overlay zomp">
                  <div class="overlay_monoton">Watering can</div>
                  <h3 class="overlay_text_description">Hand printed linocut of a watering can.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/834890880/watering-can-linocut-gardening-gardener?ref=shop_home_feat_2" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card">
            <div className="img__container">
              <div className="image">			
                <img src={etsy2} alt="Etsy shop example work" />
                <div class="overlay red__salsa">
                  <div class="overlay_monoton">Smoking pigeons</div>
                  <h3 class="overlay_text_description">15cm x 15cm professionally printed artwork. Based on my Linoprint of two smoking pigeons.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/860863981/smoking-pigeons-limited-edition-artwork?ref=shop_home_feat_3" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card">
            <div className="img__container">
              <div className="image">			
                <img src={etsy3} alt="Etsy shop example work" />
                <div class="overlay queen__blue">
                  <div class="overlay_monoton">Christmas lucky cat</div>
                  <h3 class="overlay_text_description">7 x 5 inches. Good quality sturdy card. Each card is hand printed and finished off with red sharpie.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/849479104/lucky-chinese-cat-christmas-linoprint?ref=shop_home_feat_4" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card">
            <div className="img__container">
              <div className="image">			
                <img src={etsy4} alt="Etsy shop example work" />
                <div class="overlay pansy__purple">
                  <div class="overlay_monoton">Hedgehog</div>
                  <h3 class="overlay_text_description">Wiggly hedgehog Linoprint. Each print is individually printed so will be slightly unique!</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/881820847/hawthorn-the-hedgehog-lino-print-hand?ref=shop_home_active_2&crt=1&fbclid=IwAR1V5Ci35oMiQfRM56KjPa6dKUEuHPHsjqsVVfQU-y5ZtCEdIdqJb440_Xw" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card ">
            <div className="img__container">
              <div className="image">			
                <img src={etsy5} alt="Etsy shop example work" />
                <div class="overlay pistachio">
                  <div class="overlay_monoton">Penguin Plod 10k</div>
                  <h3 class="overlay_text_description">This is the 4th virtual running event I've organised in 2020. Run 10K, anywhere you like and whenever you like before the end of 2020.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/873654995/the-2020-penguin-plod-10k-virtual?ref=shop_home_active_2&frs=1&crt=1" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card red__salsa">
            <div className="img__container">
              <div className="image">			
                <img src={etsy6} alt="Etsy shop example work" />
                <div class="overlay yellow__orange">
                  <div class="overlay_monoton">Vintage Swallow</div>
                  <h3 class="overlay_text_description">A5 hand carved Linoprint. Black ink, with added watercolour.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/758141181/vintage-tattoo-swallow-linoprint-with?ref=shop_home_active_3" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card independence">
            <div className="img__container">
              <div className="image">			
                <img src={etsy7} alt="Etsy shop example work" />
                <div class="overlay pistachio">
                  <div class="overlay_monoton">Love Knuckles</div>
                  <h3 class="overlay_text_description">A4 artwork based on my original Linoprint - available in other colours.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/771928725/blue-love-knuckles-tattoo-artwork-by?ref=shop_home_active_8" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card red__salsa">
            <div className="img__container">
              <div className="image">			
                <img src={etsy8} alt="Etsy shop example work" />
                <div class="overlay red__salsa">
                  <div class="overlay_monoton">Unicorn</div>
                  <h3 class="overlay_text_description">Hand printed unicorn lino print card. Printed on 7 x 5 inch card. Blank inside for your own message.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/863445446/cute-unicorn-lino-print-greetings-card?ref=shop_home_active_6" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card">
            <div className="img__container">
              <div className="image">			
                <img src={etsy9} alt="Etsy shop example work" />
                <div class="overlay zomp">
                  <div class="overlay_monoton">Mr Whiskers</div>
                  <h3 class="overlay_text_description">7 x 5 inch card of a black cat looking out of the patio doors.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/863424736/mr-whiskers-the-cat-lino-print-7-x-5?ref=shop_home_active_7" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card queen__blue">
            <div className="img__container">
              <div className="image">			
                <img src={etsy11} alt="Etsy shop example work" />
                <div class="overlay pistachio">
                  <div class="overlay_monoton">Ayup duck</div>
                  <h3 class="overlay_text_description">Pack of four ayup duck beer mats.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/873420121/ayup-duck-beer-mats-pack-of-four?ref=shop_home_active_11" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card queen__blue">
            <div className="img__container">
              <div className="image">			
                <img src={etsy12} alt="Etsy shop example work" />
                <div class="overlay yellow__orange">
                  <div class="overlay_monoton">Blue Fish</div>
                  <h3 class="overlay_text_description">Size A4 Linoprint of fish with blue ink on white card. Each piece is printed by hand and signed.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/804411381/size-a4-linoprint-blue-ink-fish-lockdown?ref=shop_home_active_12" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
        <div className="gallery_grid_item">
          <article className="image__card">
            <div className="img__container">
              <div className="image">			
                <img src={etsy13} alt="Etsy shop example work" />
                <div class="overlay pansy__purple">
                  <div class="overlay_monoton">subbuteo player</div>
                  <h3 class="overlay_text_description">Hand printed and personalised subbuteo style player. Any team. Shirt number can be added.</h3>
                  <h3 class="underline overlay_text"><a href="https://www.etsy.com/uk/listing/856430252/personalised-subbuteo-player-lino-print?ref=shop_home_active_17" target="blank">Buy it here</a></h3>
                </div>
              </div> 
            </div>
          </article>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
